var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.45209 16.001H4.84607V7.761L0 4.125V14.5432C0 15.3499 0.651137 16.001 1.45209 16.001Z",
    fill: "#517BBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4801 15.9992H19.8741C20.675 15.9992 21.3262 15.3481 21.3262 14.5471V4.12891L16.4801 7.7649V15.9992Z",
    fill: "#31A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4801 1.45961V7.75778L21.3262 4.12178V2.18566C21.3262 0.387825 19.2748 -0.63786 17.8342 0.439686L16.4801 1.45961Z",
    fill: "#FBBC08"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.84607 7.7591V1.46094L10.6602 5.82298L16.4743 1.46094V7.7591L10.6602 12.1211L4.84607 7.7591Z",
    fill: "#E84336"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.18467V4.1208L4.84607 7.75679V1.45863L3.48618 0.438705C2.05137 -0.638841 0 0.392607 0 2.18467Z",
    fill: "#C6221F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.cb59cfd699cc642db9caf9f76c690289.svg";
export { ForwardRef as ReactComponent };